import { RigidBody } from "@react-three/rapier"
import { useEffect, useRef } from "react"


export default function Floor() {
  const floor = useRef()

  return (
    <RigidBody type="fixed" >
      <mesh
        ref={floor}
        rotation={[-Math.PI / 2, 0, 0]} 
        position={[0, -5, 0]}        
        scale={4}
      >
        <planeGeometry args={[100, 100]} />
        <meshBasicMaterial color={'white'} /> 
      </mesh>
    </RigidBody >
  )
}
